import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { Component } from '@angular/core';

export interface ICustomHeaderParams {
  editIcon: string;
}

@Component({
  selector: 'app-custom-header',
  template: `
    <div (click)="onSortRequested($event)" class="agcustom-header-class">
      <div class="agcustom-header-content">
        <!-- Edit Icon-->
        <mat-icon
          *ngIf="params.editIcon"
          class="icon-cell"
          role="img"
          aria-hidden="true"
          [svgIcon]="params.editIcon"
        ></mat-icon>

        <!-- Header Name-->
        <div class="customHeaderLabel">{{ params.displayName }}</div>

        <!-- Sort Icons-->
        <span *ngIf="columnIsSortable" class="sort-icon">
          <i *ngIf="sort === null" class="p-sortable-column-icon pi pi-fw pi-sort-alt"></i>
          <i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt sort-icon-color" *ngIf="sort === 'asc'"></i>
          <i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down sort-icon-color" *ngIf="sort === 'desc'"></i>
          <span class="sort-icon-color">{{ sort ? this.sortIndex : null }}</span>
        </span>
      </div>
    </div>
  `,
  styleUrls: ['ag-header.component.scss'],
  standalone: false,
})
export class CustomHeaderComponent implements IHeaderAngularComp {
  public params: IHeaderParams & ICustomHeaderParams;
  public columnIsSortable = false;
  public sort: 'asc' | 'desc' | null;
  public sortIndex: number;

  agInit(params: IHeaderParams & ICustomHeaderParams): void {
    this.params = params;
    this.columnIsSortable = params.column.getColDef().sortable;
    this.setSortAndOrder();
    params.api.addEventListener('sortChanged', this.onSortChanged.bind(this));
  }

  onSortChanged() {
    this.setSortAndOrder();
  }

  onSortRequested($event) {
    if (this.columnIsSortable) {
      this.sort = this.getNewSort();
      this.params.setSort(this.sort, $event.metaKey || $event.ctrlKey);
    }
  }

  private getNewSort(): 'asc' | 'desc' {
    if (this.sort === 'asc') {
      return 'desc';
    }
    if (!this.sort || this.sort === 'desc') {
      return 'asc';
    }
  }

  private setSortAndOrder(): void {
    const currentColumn = this.params.api.getColumnState().find(x => x.colId === this.params.column.getColId());
    if (currentColumn) {
      this.sort = currentColumn.sort as 'asc' | 'desc' | null;
      this.sortIndex = currentColumn.sortIndex !== null ? currentColumn.sortIndex + 1 : null;
    }
  }

  refresh(_params: IHeaderParams) {
    return false;
  }
}
